import { SplashScreen } from '@capacitor/splash-screen';

import { istGeraet } from './gleis';

/**
 * Nimmt die Startgrafik weg.
 *
 * Sie steht, bis wir sie wegnehmen: `capacitor.config.ts` setzt `launchAutoHide: false`,
 * weil `main.tsx` erst hydriert und dann rendert. Eine feste Dauer träfe diesen Zeitpunkt
 * nicht — zu kurz, und zwischen Grafik und fertigem Bogen blitzt der leere WebView auf; zu
 * lang, und die App steht fertig hinter einer Grafik.
 *
 * ⚠️ **Darf nie werfen und muss mehrfach aufrufbar sein.** Sie wird von drei Stellen gerufen
 * (Regelfall, Fehlerzweig, Rückfalluhr — alle in `main.tsx`), und käme sie nicht durch, hinge
 * die App für den Prüfer sichtbar hinter der Grafik fest. Das sähe aus wie ein Absturz.
 */
let schonWeg = false;

export function verbergeSplash(): void {
  if (schonWeg) return;
  schonWeg = true;
  // Auf dem Rechner gibt es keine Startgrafik — der Aufruf liefe ins Leere und protokollierte
  // nur eine Warnung des Plugins.
  if (!istGeraet()) return;
  void SplashScreen.hide({ fadeOutDuration: 220 }).catch(() => {
    /* Die Grafik ist entweder schon weg oder das Plugin fehlt — beides kein Grund zu stören. */
  });
}

/** Nur für Tests: den Merker zurückstellen, damit jeder Fall frisch anfängt. */
export function _splashMerkerZuruecksetzen(): void {
  schonWeg = false;
}
